/* ============================================================
   DW Product Tabs — lightweight tab switcher
============================================================ */
(function () {
  'use strict';

  function initTabs(container) {
    const tabBtns  = container.querySelectorAll('[data-dw-tab-btn]');
    const tabPanes = container.querySelectorAll('[data-dw-tab-pane]');

    if (!tabBtns.length) return;

    function activateTab(targetId) {
      tabBtns.forEach(function (btn) {
        const isActive = btn.dataset.dwTabBtn === targetId;
        btn.classList.toggle('dw-tab-btn--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      tabPanes.forEach(function (pane) {
        const isActive = pane.dataset.dwTabPane === targetId;
        pane.classList.toggle('dw-tab-pane--active', isActive);
        if (isActive) {
          pane.removeAttribute('hidden');
        } else {
          pane.setAttribute('hidden', '');
        }
      });
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.dataset.dwTabBtn);
      });
    });

    // Activate first tab by default
    if (tabBtns[0]) activateTab(tabBtns[0].dataset.dwTabBtn);
  }

  function boot() {
    document.querySelectorAll('[data-dw-tabs]').forEach(initTabs);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-dw-tabs]');
    if (root) initTabs(root);
  });
})();
